/* tslint:disable */
/* eslint-disable */
/**
 * Citrus API Reference
 * Complete reference documentation for the Citrus API.
 *
 * The version of the OpenAPI document: 0.112.0
 * Contact: info@citruscamps.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ProductCategoryCreateParams
 */
export interface ProductCategoryCreateParams {
    /**
     * 
     * @type {string}
     * @memberof ProductCategoryCreateParams
     */
    program_id: string;
    /**
     * 
     * @type {string}
     * @memberof ProductCategoryCreateParams
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof ProductCategoryCreateParams
     */
    parent_id?: string;
    /**
     * The ID of the product category that the new category should come after in the list of categories. If the after_id property is specified, the new category will be inserted immediately after the category with the specified ID. If the after_id property is not specified, the new category will be added to the end of the list
     * @type {string}
     * @memberof ProductCategoryCreateParams
     */
    after_id?: string;
}

export function ProductCategoryCreateParamsFromJSON(json: any): ProductCategoryCreateParams {
    return ProductCategoryCreateParamsFromJSONTyped(json, false);
}

export function ProductCategoryCreateParamsFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProductCategoryCreateParams {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'program_id': json['program_id'],
        'name': json['name'],
        'parent_id': !exists(json, 'parent_id') ? undefined : json['parent_id'],
        'after_id': !exists(json, 'after_id') ? undefined : json['after_id'],
    };
}

export function ProductCategoryCreateParamsToJSON(value?: ProductCategoryCreateParams | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'program_id': value.program_id,
        'name': value.name,
        'parent_id': value.parent_id,
        'after_id': value.after_id,
    };
}

